import { isMobile, selfInstantiateOnLoad } from "../utils";
import SlpNoResultsForm from "./slpNoResultsForm";
import SlpRefinement from "./slpRefinement";
import SpecialCardFields from "./specialCardFields";
const filteredOutClass = "card__filtered";
export function buildAdditionalData(form) {
    const comments = [];
    if (form.commentAddition?.value) {
        comments.push(form.commentAddition.value);
    }
    const offerValue = form
        .closest(".card")
        .querySelector("card__offerValue p")?.textContent;
    if (offerValue) {
        comments.push(`Value: ${offerValue}`);
    }
    comments.push(`URL: ${window.location.href}`);
    if (form.DoNotSellPersonalInfo) {
        comments.push(`Do Not Sell Personal Info: ${form.DoNotSellPersonalInfo.checked}`);
    }
    const childDealerSelect = form.ChildDealerId;
    if (childDealerSelect) {
        const name = childDealerSelect.options[childDealerSelect.selectedIndex].textContent;
        const id = childDealerSelect.value;
        comments.push(`ChildDealerName: ${name}, ChildDealerId: ${id}`);
    }
    const year = form.VehicleYear?.value;
    const make = form.VehicleMake?.value;
    const model = form.VehicleModel?.value;
    const trim = form.VehicleTrim?.value;
    return {
        Comments: comments.join("; "),
        VehicleYear: year ?? undefined,
        VehicleMake: make ?? undefined,
        VehicleModel: model ?? undefined,
        VehicleTrim: trim ?? undefined,
    };
}
export default class SpecialsListingBlock {
    constructor() {
        this.$ = globalThis.jQuery;
        this.dealeronLead = globalThis.DealeronLead;
        this.getInitData = () => {
            const script = document.getElementById("slpInitData");
            if (!script) {
                console.warn("Could not find #slpInitData JSON script block.");
                return null;
            }
            try {
                return JSON.parse(script.textContent);
            }
            catch (err) {
                console.error("Error parsing the contents of #slpInitData", err);
                return null;
            }
        };
        // Filtering
        this.adjustGrid = () => {
            if (!this._isEvenRows) {
                this.refreshColcadeGrid();
                return;
            }
            const cardsByRow = [];
            let currentRow = [];
            let visibleCardsInRow = 0;
            for (const card of this._cards) {
                currentRow.push(card.parentElement);
                if (card.classList.contains(filteredOutClass)) {
                    continue;
                }
                visibleCardsInRow++;
                if (visibleCardsInRow === this._columns) {
                    cardsByRow.push(currentRow);
                    visibleCardsInRow = 0;
                    currentRow = [];
                }
            }
            if (currentRow.length > 0) {
                cardsByRow.push(currentRow);
            }
            this.refillGridRows(cardsByRow);
        };
        this.filter = (offerFilter, typeFilters, tagFilters) => {
            for (const card of this._cards) {
                const isFilteredOutByOfferType = offerFilter !== "" && !card.classList.contains(`tag--${offerFilter}`);
                const isFilteredOutByType = typeFilters.length > 0 &&
                    !typeFilters.some((t) => card.classList.contains(`type--${t}`));
                const isFilteredOutByTag = tagFilters.length > 0 &&
                    !tagFilters.some((t) => card.classList.contains(`tag--${t}`));
                const isFilteredOut = isFilteredOutByOfferType || isFilteredOutByType || isFilteredOutByTag;
                const isHidden = card.classList.contains(filteredOutClass);
                if (isFilteredOut && !isHidden) {
                    card.classList.add(filteredOutClass);
                    if (this._isEvenRows) {
                        card.parentElement.classList.remove("even__cols");
                        card.parentElement.setAttribute("hidden", "true");
                    }
                }
                else if (!isFilteredOut && isHidden) {
                    card.classList.remove(filteredOutClass);
                    if (this._isEvenRows) {
                        card.parentElement.classList.add("even__cols");
                        card.parentElement.removeAttribute("hidden");
                    }
                }
            }
            this.adjustGrid();
            this.showHideNoResultsForm();
        };
        // EvenRows grid only
        this.refillGridRows = (cardsByRow) => {
            const rows = document.querySelectorAll(".row__element");
            for (let i = 0; i < rows.length; i++) {
                const row = rows[i];
                const cards = cardsByRow[i] ?? [];
                row.replaceChildren(...cards);
            }
        };
        // Collapsed grid only
        this.refreshColcadeGrid = () => {
            this.$(".card__container").colcade("destroy");
            const container = this.$("#cards__Container");
            container.data("colcade", null);
            container
                .find(".card__coupon:not(.card__filtered)")
                .sort((a, b) => a.dataset.specialOrder - b.dataset.specialOrder)
                .appendTo(container);
            this.$(".card__container").colcade({
                columns: ".slp-col",
                items: ".card__coupon:not(.card__filtered)",
            });
        };
        this.showHideNoResultsForm = () => {
            const allCardsFilteredOut = this._cards.length === 0 ||
                this._cards.every((c) => c.classList.contains(filteredOutClass));
            this._noResultsForm.setFormVisibility(allCardsFilteredOut);
        };
        // Leads
        this.getAdditionalData = (form) => buildAdditionalData(form);
        this.setupCardLeadForms = () => {
            const formCards = this._cards.filter((c) => c.querySelector("form"));
            const options = {
                leadSource: (form) => {
                    if (this._isMobile) {
                        return parseInt(form.mobileLeadSource.value);
                    }
                    return parseInt(form.desktopLeadSource.value);
                },
                additionalData: this.getAdditionalData,
            };
            this.dealeronLead.addSubmissionMethod("specialsSubmitMethod", options);
            for (const card of formCards) {
                const form = card.querySelector("form");
                this.dealeronLead.initialize(`#${form.getAttribute("id")}`, "specialsSubmitMethod");
                form.FirstName.addEventListener("blur", () => this.dealeronLead.begin());
            }
        };
        const initData = this.getInitData() ?? {
            columns: 1,
            isEvenRows: document.querySelector(".row.row__element") !== null,
            readLessButtonText: "Read Less",
            readMoreButtonText: "Read More",
        };
        this._cards = Array.from(document.querySelectorAll(".card__coupon"));
        this._columns = initData.columns;
        this._isEvenRows = initData.isEvenRows;
        this._isMobile = isMobile();
        this._noResultsForm = new SlpNoResultsForm();
        if (this._cards.length > 0 &&
            this._cards.every((c) => c.classList.contains(filteredOutClass))) {
            this._noResultsForm.setFormVisibility(true);
        }
        if (!this._isEvenRows) {
            this.refreshColcadeGrid();
        }
        if (document.getElementById("slpRefinement")) {
            new SlpRefinement(this.filter, initData);
        }
        if (this._cards.length > 0) {
            new SpecialCardFields(initData);
            this.setupCardLeadForms();
        }
        const containers = document.querySelectorAll(".card__container");
        for (const container of containers) {
            container.classList.add("card__container--loaded");
        }
    }
}
selfInstantiateOnLoad(SpecialsListingBlock);
